import {CfpVariableViewType} from '../shared/helpers';
import {CfpByMultilevel, ProcedureSummaryDrill, ProcedureSummaryDrillImpl} from './ClinicalSummary';
import {CptGroup} from './procedure-summary/ProcedureSummaryModels';
import {CptViewType} from '../shared/enums';

export const cfpVariablesWithInfo = [
  {
    value: CfpVariableViewType.CfteAdjustedwRVU,
    display: 'cFTE adj. wRVUs'
  },
  {
    value: CfpVariableViewType.ActualwRVU,
    display: 'Actual wRVUs'
  },
  {
    value: CfpVariableViewType.CfteAdjustedCount,
    display: 'cFTE adj. Count'
  },
  {
    value: CfpVariableViewType.ActualCount,
    display: 'Count'
  }
];

export function filterCfpDataBasedOnCptGroupAndDrill(cfpData: CfpByMultilevel[], cptDrill?: ProcedureSummaryDrillImpl,
                                                     cptGroup?: CptGroup): CfpByMultilevel[] {
  return filterDimensionalDataBasedOnCptGroup(
    (cptDrill ? filterDimensionalDataBasedOnDrill(cptDrill.drillObject, cfpData) : cfpData), cptGroup);
}

function filterDimensionalDataBasedOnDrill(drill: ProcedureSummaryDrill, data: CfpByMultilevel[]): CfpByMultilevel[] {
  switch (drill.viewType) {
    case CptViewType.CptRange: return data.filter(x => x.cptFamilyDesc === drill.cfp.cptFamilyDesc);
    case CptViewType.CptCode: return data.filter(x => x.cptFamilyDesc === drill.cfp.cptFamilyDesc &&
      x.cptRangeDesc === drill.cfp.cptRangeDesc);
  }
  return data;
}

function filterDimensionalDataBasedOnCptGroup(data: CfpByMultilevel[], group?: CptGroup): CfpByMultilevel[] {
  if (!group) {
    return data;
  }
  const allowedFamilies: string[] = [];
  const allowedRanges: string[] = [];
  const allowedCodes: string[] = [];
  group.entries.forEach(entry => {
    switch (entry.cptViewType) {
      case CptViewType.CptFamily:
        allowedFamilies.push(entry.cptDesc);
        break;
      case CptViewType.CptRange:
        allowedRanges.push(entry.cptDesc);
        break;
      case CptViewType.CptCode:
        allowedCodes.push(entry.cptDesc);
    }
  });
  return data.filter(x => {
    return allowedFamilies.includes(x.cptFamilyDesc) || allowedRanges.includes(x.cptRangeDesc)
      || allowedCodes.includes(x.cptCode);
  });
}
